"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const ArgusMenuContactUs_1 = tslib_1.__importDefault(require("./ArgusMenuContactUs"));
const ArgusMenuLink_1 = tslib_1.__importDefault(require("./ArgusMenuLink"));
const ArgusMenuLogin = ({ logger, sx }) => {
    return (react_1.default.createElement(Box_1.default, { ...{ sx: { margin: 1, display: "flex", flexDirection: "row", ...sx } } },
        react_1.default.createElement(ArgusMenuContactUs_1.default, { ...{
                kind: "contactUs",
                iconId: "none",
                label: "Contact us",
                logger,
                ArgusMenuButtonProps: {
                    disableShrinking: true,
                    disableIconOffset: true,
                    ListItemTextProps: { sx: { color: "primary.contrastText", whiteSpace: "nowrap" } },
                    ListItemProps: { sx: { p: 0 } },
                },
            } }),
        react_1.default.createElement(ArgusMenuLink_1.default, { ...{
                iconId: "none",
                label: "Login",
                logger,
                href: "authentication/login",
                kind: "internalLink",
                disableIconOffset: true,
                disableShrinking: true,
                ListItemProps: { sx: { p: 0 } },
                ListItemTextProps: { sx: { p: 0, color: "primary.contrastText" } },
            } })));
};
exports.default = ArgusMenuLogin;
